<nb-card class="dialog">
  <!-- <nb-card class="dialog"> -->
  <nb-card-header class="header">
    <div data-testid="datasource-preview-name" class="right-side">
      <p class="title" data-testid="preview-title">{{previewDataSourceInfo?.fileName}}</p>
    </div>
    <div class="left-side">
      <p class="text">ردیف</p>
      <button data-testid="100-row" class="button" [ngClass]="{'active' : rowNumber === hundred}" (click)="loadTableContent(hundred)">
        100
      </button>
      <button data-testid="200-row" class="button" [ngClass]="{'active' : rowNumber === twoHundred}" (click)="loadTableContent(twoHundred)">
        200
      </button>
      <button data-testid="1000-row" class="button" [ngClass]="{'active' : rowNumber === thousand}" (click)="loadTableContent(thousand)">
        1000
      </button>
      <morva-icons class="icon" icon="changeDataType"></morva-icons>
      <p data-testid="change-data-type" class="text" [matMenuTriggerFor]="dataType" #menuTrigger="matMenuTrigger" (menuOpened)="openMenuDataType()">تغییر نوع داده</p>
    </div>
  </nb-card-header>
  <mat-menu #dataType="matMenu" class="change-type">
    <input
      #searchType
      data-testid="search-input"
      nbInput
      type="search"
      class="search-input"
      placeholder="جستجو"
      (input)="searchInColumnsTypes(searchType.value)"
      (click)="$event.stopPropagation()"
    />
    <div class="options">
      <div
        class="options-row"
        *ngFor="let column of showColumnsTypes | keyvalue"
        (click)="$event.stopPropagation()"
      >
        <p class="limit-text" [nbTooltipTrigger]="column.key?.length > 10 ? 'hover' : 'noop'" [nbTooltip]="column.key">{{ column.key }}</p>
        <ng-select
          data-testid="data-type-preview-select"
          #search
          appendTo="body"
          class="data-type-preview-select"
          bindLabel="type"
          bindValue="type"
          [items]="types"
          [searchable]="false"
          [ngModel]="column.value"
          (ngModelChange)="setColumnType($event, column.key)"
        >
        </ng-select>
      </div>
    </div>
    <button data-testid="save-btn" class="save-btn" nbButton (click)="saveChangedColumnsType()">ذخیره</button>
  </mat-menu>
  <nb-card-body class="body">
    <div class="d-flex justify-content-start align-items-center">
      <div class="sheets-container" [nbSpinner]="loadingSheetNames">
        <p class="sheet-text">انتخاب شیت برای بارگذاری</p>
        <nb-radio-group (valueChange)="changeSheet($event)">
          <nb-radio data-testid="sheet-radio" *ngFor="let sheetName of sheetNames" [value]="sheetName" [checked]="selectedSheetName === sheetName"
            [disabled]="loading">
            <span class="sheet-name" [nbTooltip]="sheetName">{{sheetName}}</span>
          </nb-radio>
        </nb-radio-group>
      </div>
      <div class="table-container d-flex flex-column" [nbSpinner]="loading" data-testid="table-container">
        <table *ngIf="columns && !hasError">
          <tr>
            <th *ngFor="let column of columns.data | keyvalue">
              {{ column.key }}
            </th>
          </tr>
          <tr *ngFor="let row of columnsDataLength">
            <td *ngFor="let column of columns.data | keyvalue">
              {{ column.value.columnData[row] }}
            </td>
          </tr>
        </table>

        <div class="excel-error my-auto d-flex flex-column justify-content-center align-items-center" *ngIf="hasError && !loading">
          <img data-testid="excel-error-img" class="excel-error" src="assets/images/excel-error.png" alt="excel-error">
          <p class="excel-error">داده‌ی موجود در صفحه موردنظر قابل‌خواندن نیست.</p>
          <small data-testid="small-excel-error-img" class="excel-error">لطفا از وجود داده‌ و صحت آن در صفحه موردنظر اطمینان حاصل کنید.</small>
        </div>
        
        <div class="excel-error my-auto d-flex flex-column justify-content-center align-items-center"*ngIf="isEmptySheet && !hasError">
          <img data-testid="excel-error-img" class="excel-error" src="assets/images/excel-empty.png" alt="excel-error">
          <p class="excel-error">داده‌ای برای نمایش وجود ندارد.</p>
          <small data-testid="small-excel-error-img" class="excel-error">جدول باید حاوی حداقل یک مقدار باشد.</small>
        </div>
      </div>
    </div>

    <div class="error-container mt-2" *ngIf="columns?.columnWarnings?.length > 0 && type === 'ReplacementDataSource'">
      <div class="px-3 py-1" *ngFor="let warning of columns.columnWarnings">
        <morva-linear-notifiction [message]="warning" messageType="error"></morva-linear-notifiction>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer class="footer">
    <button (click)="deletePreviewConnection()">خروج</button>
    <button (click)="save()" [disabled]="isUploading || isEmptySheet" [nbSpinner]="isUploading">بارگذاری</button>
  </nb-card-footer>
</nb-card>
